import './live-qr-frame.scss';
import React, { PropsWithChildren } from 'react';

const LiveQrFrame = ({ children }: PropsWithChildren) => (
  <div className="live-qr-frame">
    <div className="live-qr-frame__glow">
      <div className="live-qr-frame__light" />
    </div>
    <div className="live-qr-frame__ring">
      <div className="live-qr-frame__light" />
      <div className="live-qr-frame__content">{children}</div>
    </div>
  </div>
);

export default LiveQrFrame;
